import { forwardRef, useContext } from 'react';
import { CommanderFormContext, TooltippedIcon } from '@mews-commander/ui';
import { IconName, TextInput } from '@optimus-web/core';

// @ts-expect-error $TSFixMeError: Property 'helper' does not exist on type '{ children?: ReactNode; }'.
export const InputField = forwardRef(({ helper, bottomCaption, disabled, ...other }, ref) => {
    const captionIconWithTooltip = helper ? (
        <TooltippedIcon size="small" value={IconName.Info} tooltip={helper} />
    ) : null;

    const { readOnlyForm } = useContext(CommanderFormContext);

    return (
        <TextInput
            disabled={readOnlyForm || disabled}
            captionIconWithTooltip={captionIconWithTooltip}
            helper={bottomCaption}
            {...other}
            // @ts-expect-error $TSFixMeError: Type 'ForwardedRef<unknown>' is not assignable to type 'Ref<HTMLElement> | undefined'.
            ref={ref}
        />
    );
});
